module.exports = __webpack_public_path__ + "img/world_earth.433ec30b.svg";